var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfilesGray(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profiles Fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 979"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 978"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 10",
    d: "M5.99998 6.69632C7.87796 6.69632 9.40035 5.19729 9.40035 3.34816C9.40035 1.49902 7.87796 0 5.99998 0C4.12201 0 2.59961 1.49902 2.59961 3.34816C2.59961 5.19729 4.12201 6.69632 5.99998 6.69632Z",
    fill: "#9C9EA9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 981"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 980"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 3175",
    d: "M6 7.72852C4.4087 7.72852 2.88258 8.35094 1.75736 9.45888C0.63214 10.5668 0 12.0695 0 13.6364C0 14.0542 0.168546 14.4548 0.468561 14.7502C0.768577 15.0456 1.17548 15.2116 1.59977 15.2116H10.4002C10.8245 15.2116 11.2314 15.0456 11.5314 14.7502C11.8315 14.4548 12 14.0542 12 13.6364C12 12.0695 11.3679 10.5668 10.2426 9.45888C9.11742 8.35094 7.5913 7.72852 6 7.72852Z",
    fill: "#9C9EA9"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilesGray);
export default __webpack_public_path__ + "static/media/profilesGray.db3629c138c03eb4f9d478b146710b5d.svg";
export { ForwardRef as ReactComponent };